import { ArrowRightLeft } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

interface SalonMismatchBannerProps {
  intendedSalonName: string | null;
  onSwitch: () => void;
  onCancel: () => void;
  switchDisabled: boolean;
}

export function SalonMismatchBanner({
  intendedSalonName,
  onSwitch,
  onCancel,
  switchDisabled,
}: SalonMismatchBannerProps) {
  return (
    <Alert>
      <ArrowRightLeft className="h-4 w-4" />
      <AlertTitle>Finish your connection on the right salon</AlertTitle>
      <AlertDescription className="space-y-2">
        <p>
          You started this Google Business connection
          {intendedSalonName ? (
            <>
              {" "}
              for <span className="font-medium">{intendedSalonName}</span>
            </>
          ) : (
            " for a different salon"
          )}
          . Switch to it to finish setup, or cancel to start over from this salon.
        </p>
        <div className="flex gap-2">
          <Button size="sm" onClick={onSwitch} disabled={switchDisabled}>
            {intendedSalonName ? `Switch to ${intendedSalonName}` : "Switch salon"}
          </Button>
          <Button size="sm" variant="ghost" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </AlertDescription>
    </Alert>
  );
}
